import styled from "styled-components";
import {Modal} from "antd"

export const StyledModal = styled(Modal)`
  .ant-modal-content{
    padding: 0 !important;
  }

  .ant-modal-close {
    color: #222222 !important;
    top : 24px !important;
    right: 24px !important;
  }

  .ant-modal-title {
    color: #222222 !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    line-height: 26px !important;

  }

  .ant-modal-header {
    padding: 24px 24px 16px 24px;
    justify-content: space-between;
    margin-bottom: 0 !important;
  }

  .ant-modal-body {
    padding: 12px 24px 12px 24px;
  }

  .ant-modal-body p {
    line-height: 24px;
  }

  .ant-modal-footer {
    padding: 24px;
  }
`